import { render, staticRenderFns } from "./TaxCode.vue?vue&type=template&id=684f0281&"
import script from "./TaxCode.vue?vue&type=script&lang=ts&"
export * from "./TaxCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports